<template>
	<button :class="['button button-save',{'button-saved':!is_saved}]" @click="doClick">
		<block-spinner :active="isLoading" size="4" :color="spinnerColor" :key="`spinner_${is_saved}`"></block-spinner>
		<template  v-if="!isLoading">
			<svg class="btn-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 15"><path d="M15.698 8.123c1.37-1.396 1.57-3.613 1.57-3.613C16.869.523 13.331.174 12.309.149h-.274c-1.918.174-3.015.872-3.613 1.744A8.258 8.258 0 007.351.946l-.225-.15C6.254.299 3.015-1.22.623 1.994c0 0-1.296 2.716-.15 4.834.274.498.673.947 1.246 1.32l3.09 3.29 2.492 2.591L8.72 15l4.236-4.336L15.4 8.422c.1-.075.2-.175.3-.3z"/></svg>
		</template>
		<span>{{ save_text }}</span>
	</button>
</template>

<script>
	import AuthMixins from '@/mixins/AuthMixins';

	export default {
		name: 'JobSaveButton',
		mixins: [AuthMixins],
		props: {
			job_id: {
				type: String
			}
		},

		data() {
			return {
				saved_jobs: false,
				isLoading: false,
			}
		},

		mounted() {
			this.saved_jobs;
		},

		methods: {
			doClick() {
				if (this.me) {
					this.toggleSave();
				} else {
					this.emitter.emit("openModal", { name: 'SignIn', persistent: false });
				}
			},
			toggleSave() {

				this.isLoading = true;

				let payload = {
	  			'job_id': this.job_id
	  		}

				if (this.is_saved) {
					this.emitter.emit('gaEventTrack', {'category':'job', 'action':'unsave', 'label':this.job_id});
				} else {
					this.emitter.emit('gaEventTrack',  {'category':'job', 'action':'save', 'label':this.job_id});
				}

	  		return this.$api.bookmarkJob(payload).then(
					(response) => {
						if (response.data.status == 'success') {
	        		this.updateUser(response.data.enc_user);
							this.isLoading = false;
	        	}
					}
				).catch((response) => {
					console.log("Could not toggle bookmark job.");
				});
			}
		},

		computed: {
			is_saved() {
				if(this.saved_jobs) {
					let found = this.saved_jobs.find((job) => {
						return job['job-id'] == this.job_id;
					});
					return (found);
				}
			},
			save_text() {
				if (this.is_saved) {
					return 'SAVED';
				}
				if (this.isLoading) {
					return 'SAVING';
				}
				return 'SAVE';
			},
			spinnerColor() {
				return this.is_saved ? 'text-white' : 'text-white';
			}
		},
		watch: {
    	me() {
    		this.saved_jobs = (this.$store.getters.getUser['saved-jobs'] !== undefined) ? this.$store.getters.getUser['saved-jobs'] : false;
    	}
    }
	}

</script>
